<template>
<div>
    <div class="selectTypeBox">
        <el-radio-group v-model="selectType" @change="onChangeSelectType">
            <el-radio-button label="上架"></el-radio-button>
            <el-radio-button label="下架"></el-radio-button>
            <el-radio-button label="审核中"></el-radio-button>
        </el-radio-group>
    </div>
    <div style="width: 80%; margin: 15px auto 15px auto">
        <el-input placeholder="请输入公司名称进行搜索" v-model="positionName" class="input-with-select" @change="changePostionName">
            <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
    </div>
    <div class="itemList">
        <div class="itemDiv" v-for="(item, index) in dataList" :key="item.id">
            <div class="leftDiv">
                <p>
                    {{item.corporate}},{{item.positionName}},{{item.salaryMin === item.salaryMax ? item.salaryMin + 'K月薪' : item.salaryMin + 'K~' + item.salaryMax + 'K月薪' }}
                    发布时间：{{item.createTime}}
                </p>
                <div v-if="item.status === 1 || item.status === 2">
                    <el-button @click="goToChangeBefore(item.id)">查看候选人列表{{Number(item.deliverNumber) > 0 ? '(' + item.deliverNumber + ')' : ''}}</el-button>
                    <el-button @click="goToMoneyReward(item.id)">佣金结算列表</el-button>
                     <el-button @click="goJobNoticeList(item.id)">职位公告列表</el-button>
                     
                    <!-- <el-button v-if="item.admin_status === 4" @click="goToChangeAfter(item.id)">佣金结算列表</el-button> -->
                </div>
            </div>
            <div class="rightDiv">
                <p v-if="item.type === 1">个人发布职位</p>
                <p v-if="item.type === 2 && item.status === 1">企业发布职位，已上架</p>
                <p v-if="item.type === 2 && item.status === 2">企业发布职位, 已关闭</p>
                <p v-if="item.type === 2 && item.status === 3">企业发布职位，待上架</p>
                <div>
                    <el-button v-if="item.status === 1" @click="closePosition1(item.id)">关闭职位</el-button>

                    <el-popover placement="top" width="160" v-model="item.showHy">
                        <p style="font-weight: bold;padding-bottom:10px;">是否按行业推送该职位</p>
                        <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="text" @click="popoverHy(index, false, item.id)">取消</el-button>
                            <el-button type="primary" size="mini" @click="popoverHy(index,  true, item.id)">确定</el-button>
                        </div>
                        <el-button slot="reference">按行业推送该职位</el-button>
                    </el-popover>

                    <el-popover placement="top" width="160" v-model="item.showZn">
                        <p style="font-weight: bold;padding-bottom:10px;">是否按职能推送该职位</p>
                        <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="text" @click="popoverZn(index, false, item.id)">取消</el-button>
                            <el-button type="primary" size="mini" @click="popoverZn(index,  true, item.id)">确定</el-button>
                        </div>
                        <el-button slot="reference">按职能推送该职位</el-button>
                    </el-popover>
                </div>
            </div>
        </div>
    </div>
    <div class="block">
        <el-pagination @current-change="handleCurrentChange" :current-page="pageNumber" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="pageTotal">
        </el-pagination>
    </div>
    <!-- <el-dialog
    title="提示"
    :visible.sync="dialogVisible1"
    width="30%">
    <span>是否上架该职位</span>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible1 = false;openPosition()">确 定</el-button>
    </span>
    </el-dialog> -->
    <el-dialog title="提示" :visible.sync="dialogVisible2" width="30%">
        <span>是否关闭该职位</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible2 = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible2 = false;closePosition()">确 定</el-button>
        </span>
    </el-dialog>
    <!-- <el-dialog
    title="提示"
    :visible.sync="dialogVisible3"
    width="30%">
    <span>是否终止与该公司的合作</span>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible3 = false;endHz()">确 定</el-button>
    </span>
    </el-dialog> -->
</div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
export default {
    name: 'position',
    props: {},
    data() {
        return {
            positionName: '',
            pageSize: 20,
            pageNumber: 1,
            pageTotal: 0,
            dataList: [],
            setid: '',
            dialogVisible1: false,
            dialogVisible2: false,
            dialogVisible3: false,
            selectType: '全部',
            selectTypeArray: {
                "上架": 1,
                "下架": 2,
                "审核中": 3
            }

        }
    },
    methods: {
        popoverHy: function (index, status, id) {
            let list = this.dataList
            list[index]['showHy'] = false
            if (status) {
                this.hyts(id)
            }
        },
        hyts: function (id) {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/job/industryMsg',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: {
                    jobId: id
                }
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.$message({
                        message: '推送成功',
                        type: 'success'
                    });
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        popoverZn: function (index, status, id) {
            let list = this.dataList
            list[index]['showZn'] = false
            if (status) {
                this.znts(id)
            }
        },
        znts: function (id) {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/job/jobTypeMsg',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: {
                    jobId: id
                }
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.$message({
                        message: '推送成功',
                        type: 'success'
                    });
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        openPosition1: function (id) {
            this.setid = id
            this.dialogVisible1 = true
        },
        closePosition1: function (id) {
            this.setid = id
            this.dialogVisible2 = true

        },
        endHz1: function (id) {
            this.setid = id
            this.dialogVisible3 = true

        },
        changePostionName: function () {
            this.pageNumber = 1
            this.getPositionLost()
        },
        getPositionLost: function () {
            let that = this
            let data = {
                status: this.selectTypeArray[this.selectType],
                pageSize: this.pageSize,
                pageNum: this.pageNumber
            }
            if (this.positionName === '') {} else {
                data.searchKey = this.positionName
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/job/getJobList',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: data
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    let demo = response.data.content.list
                    for (let i in demo) {
                        demo.showHy = false
                        demo.showZn = false
                        if (demo[i].userInfo) {
                            demo[i].userObj = JSON.parse(demo[i].userInfo)
                        }
                    }
                    that.dataList = demo
                    that.pageTotal = response.data.content.total
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        handleCurrentChange: function (val) {
            this.pageNumber = val
            this.getPositionLost()
        },
        // openPosition: function () {
        //     let id = this.setid
        //     let that = this
        //    axios({
        //         method: 'GET',
        //         url: Config.path + '/api/v1.0/job/upJob/' + id,
        //         headers: {'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},
        //         params: {},
        //         data: {}
        //     }).then(function(response) {
        //         // eslint-disable-next-line
        //         console.log(response)
        //         if (response.data.success === '1') {
        //             that.$message({
        //                 message: '上架职位成功',
        //                 type: 'success'
        //             });
        //             that.getPositionLost()
        //         } else {
        //             that.$message({
        //                 message: response.data.message,
        //                 type: 'warning'
        //             });
        //         }
        //     }).catch(function(error) {
        //          // eslint-disable-next-line
        //         console.log(error)
        //     })
        // },
        closePosition: function () {
            let id = this.setid
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/job/closeJob',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: {
                    jobId: id
                }
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.$message({
                        message: '关闭职位成功',
                        type: 'success'
                    });
                    that.getPositionLost()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        // endHz: function () {
        //                 let id = this.setid
        //     let that = this
        //    axios({
        //         method: 'GET',
        //         url: Config.path + '/api/v1.0/admin/endCooperation/' + id,
        //         headers: {'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},
        //         params: {},
        //         data: {}
        //     }).then(function(response) {
        //         // eslint-disable-next-line
        //         console.log(response)
        //         if (response.data.success === '1') {
        //             that.$message({
        //                 message: '与该公司合作已经结束',
        //                 type: 'success'
        //             });
        //             that.getPositionLost()
        //         } else {
        //             that.$message({
        //                 message: response.data.message,
        //                 type: 'warning'
        //             });
        //         }
        //     }).catch(function(error) {
        //          // eslint-disable-next-line
        //         console.log(error)
        //     })
        // },
        goToChangeBefore: function (id) {
            this.$router.push({
                path: '/changeBefore',
                query: {
                    id: id
                }
            })
        },
        goToChangeAfter: function (id) {
            this.$router.push({
                path: '/changeAfter',
                query: {
                    id: id
                }
            })
        },
        goToMoneyReward: function (id) {
            this.$router.push({
                path: '/moneyReward',
                query: {
                    id: id
                }
            })
        },
        goJobNoticeList: function (id) {
            this.$router.push({
                path: '/jobNotice',
                query: {
                    id: id
                }
            })
        },
        onChangeSelectType(e) {
            this.pageSize = 20,
                this.pageNumber = 1,
                this.selectType = e
            this.getPositionLost()
        },
    },
    mounted: function () {
        this.getPositionLost();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.itemList {
    margin-top: 20px;
}

.itemList .itemDiv {
    background-color: #ffffff;
    width: 80%;
    margin: 0 auto 15px auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 25px;
    border-radius: 8px;
    min-height: 200px;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
}

.itemList .itemDiv .leftDiv {
    width: 70%;
}

.itemList .itemDiv .leftDiv p {
    font-size: 18px;
    color: #757373;
}

.itemList .itemDiv .leftDiv div {
    padding: 30px 0;
}

.itemList .itemDiv .rightDiv {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
}

.itemList .itemDiv .rightDiv p {
    font-size: 32px;
    color: #1AAD19;
    text-align: center;
}

.itemList .itemDiv .rightDiv div {
    padding: 30px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}

.block {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
}
</style>
